import { StateCreator } from "zustand";

export interface MirageDrawerState {
    isOpen: boolean;
}

export interface MirageDrawerSlice {
    mirageDrawer: MirageDrawerState;
    setMirageDrawer: (state: MirageDrawerState) => void;
    openMirageDrawer: () => void;
    closeMirageDrawer: () => void;
}

const initialMirageDrawerState: MirageDrawerState = { isOpen: false };

export const createMirageDrawerSlice: StateCreator<MirageDrawerSlice, [], [], MirageDrawerSlice> = (set) => ({
    mirageDrawer: initialMirageDrawerState,

    setMirageDrawer: (state) => set({ mirageDrawer: state }),
    openMirageDrawer: () => set({ mirageDrawer: { isOpen: true } }),
    closeMirageDrawer: () => set({ mirageDrawer: { isOpen: false } }),
});

